import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { RequiredTag } from '../RequiredTag'

import { titleRootVariant, titleLineVariant } from './title-variants'

type Props = ComponentPropsWithoutRef<'div'> & {
  size?: 'default' | 'large' | 'small'
  lineColor?: 'primary' | 'gray'
  required?: boolean
}

/**
 * タイトル
 */
export const Title: FC<Props> = ({
  className,
  children,
  size = 'default',
  lineColor = 'primary',
  required = false,
  ...props
}) => {
  return (
    <div {...props} className={clsx([titleRootVariant({ size }), className])}>
      <div className={titleLineVariant({ size, lineColor })} />
      {children}
      {required && <RequiredTag />}
    </div>
  )
}
